import { FolkHull } from '../folk-hull';
FolkHull.define();
export { FolkHull };
//# sourceMappingURL=folk-hull.js.map